import { getClientByName } from '../services/clients'
import { generateTicketDelivery } from '../services/reports'

export const filterDeliveries = (List) => {
  const deliveriesList = []
  const filterOnlyPendientDeliveries = List.filter(
    (item) =>
      item.estado !== 'Envío Completado' && item.estado !== 'En Tránsito'
  )

  filterOnlyPendientDeliveries.forEach(function (item) {
    deliveriesList.push(item)
  })

  const deliveriesSorted = deliveriesList.sort((p1, p2) =>
    p1.date > p2.date ? 1 : p1.date < p2.date ? -1 : 0
  )

  return deliveriesSorted
}

export const isWithinDateRange = (nomina, deliveriesItem) => {
  // Convertir las fechas a formato ISO y extraer solo la fecha (YYYY-MM-DD)
  const deliveryDate = new Date(deliveriesItem.date).toISOString().split('T')[0]

  const initialDateObj = new Date(nomina.initialDate)
  const initialDateOfWeek = initialDateObj.getDay()

  const daysToSubtractForSat = (initialDateOfWeek + 1) % 7
  initialDateObj.setDate(initialDateObj.getDate() - daysToSubtractForSat)
  const initialDate = initialDateObj.toISOString().split('T')[0]

  const finalDateObj = new Date(nomina.finalDate)
  const finalDayOfWeek = finalDateObj.getDay()

  const daysToSubtractForFri = (finalDayOfWeek - 5 + 7) % 7
  finalDateObj.setDate(finalDateObj.getDate() - daysToSubtractForFri)
  const finalDate = finalDateObj.toISOString().split('T')[0]

  // Comprobar que deliveryDate esté en el rango de fechas
  return deliveryDate >= initialDate && deliveryDate <= finalDate
}

export const getClient = async (name) => {
  let data = {}

  const client = await getClientByName(name) // Espera correctamente

  if (client) {
    data = {
      cliente: client.nombre,
      lugar: client.calle + ' #' + client.numero + ', ' + client.colonia,
      referencia: client.referencia + ' TELEFONO: ' + client.telefono,
      localidad: client.poblacion + ', ' + client.municipio,
    }
  } else {
    data = {
      cliente: 'Cliente no encontrado',
      lugar: '',
      referencia: '',
    }
  }

  generateTicketDelivery(data) // Se ejecuta solo después de tener los datos
}
